import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { EntitiesPropType, PaginationPropType } from 'propTypes/common';
import Catalog from 'components/catalogs/Catalog';
import Grid from 'components/Grid';
import Pagination from 'components/Pagination';

import PersonCard from 'components/cards/entities/PersonCard';

const PersonsCatalog = ({ persons: { pagination, items } }) => (
	<Catalog
		footer={
			pagination.total > 1 ? (
				<Pagination total={pagination.total} current={pagination.current} />
			) : null
		}
		emptyMessage="К сожалению, персон по вашему запросу не найдено"
	>
		{!_.isEmpty(items) && (
			<Grid
				colDefault={2}
				colMobileMedium={3}
				colMobileLarge={4}
				colTabletMedium={5}
				colTabletLarge={6}
			>
				{items.map((person) => (
					<PersonCard entity={person} key={person._id} />
				))}
			</Grid>
		)}
	</Catalog>
);

PersonsCatalog.propTypes = {
	persons: PropTypes.shape({
		pagination: PaginationPropType.isRequired,
		total: PropTypes.number,
		items: EntitiesPropType.isRequired
	}).isRequired
};

export default PersonsCatalog;
